import { render, staticRenderFns } from "./configuration-automation-protocols-grid.vue?vue&type=template&id=0a9c920f&scoped=true&"
import script from "./configuration-automation-protocols-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-protocols-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-protocols-grid.scss?vue&type=style&index=0&id=0a9c920f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c920f",
  null
  
)

export default component.exports